import { createAction } from '../../../store.model';
import { ImprovementGroupDto, PerformanceClassDto } from '../../core';
import { ActionType } from '../main.action';
import { FilterItemView } from '../model/filter-item-view.model';

export interface ToggleFilterButton {
    item: FilterItemView<PerformanceClassDto | ImprovementGroupDto>;
}

export const toggleFilterButton = createAction<ActionType, ToggleFilterButton>(
    ActionType.MI2_MAIN__TOGGLE_FILTER_BUTTON,
);
